// Sepang elevation profile: height of each SEPANG_CENTRELINE point relative to the start line, metres.
//
// GENERATED by scripts/sepang-geometry.mjs (see docs/research/sepang-geometry.md); do not edit by hand.
//
// Source: Copernicus DEM GLO-30 (2021 release), tile Copernicus_DSM_COG_10_N02_00_E101_00_DEM, from the
// AWS open-data bucket copernicus-dem-30m. Free for the general public under the ESA/Copernicus DEM licence;
// as this profile adapts the data, the required notice is:
//   "produced using Copernicus WorldDEM-30 (c) DLR e.V. 2010-2014 and (c) Airbus Defence and Space GmbH
//   2014-2018 provided under COPERNICUS by the European Union and ESA; all rights reserved"
// Building footprints used to mask the DEM: (c) OpenStreetMap contributors, ODbL.
//
// Method: the DEM is a surface model (trees and roofs included, ~30 m posts), so per centreline point it
// samples 9 points across the track (+-12 m, bilinear), drops those within 25 m of an OSM
// building and keeps the 25th percentile; points with < 3 clean samples (275 of 1108: the main straight
// between the pit building and main grandstand, and the back straight by its grandstand) are interpolated
// linearly along the track. Then, along the track: running median over
// +-75 m, Gaussian sigma 25 m, grades capped at
// 8% (closed loop preserved); then y = 0 at index 0. DEM vertical accuracy is a few metres,
// so treat this as the shape of the terrain (+-1-2 m), not survey data.
// Start line 37.8 m above the EGM2008 geoid. Min -14.72 m, max 6.19 m
// (range 20.9 m), total climb 34.1 m per lap, steepest grade 5.4%.

/** Height (m) of each SEPANG_CENTRELINE point relative to index 0 (same order and length). */
export const SEPANG_ELEVATION: number[] = [
  0.00, 0.00, 0.00, 0.00, -0.01, -0.01, -0.01, -0.01, -0.01, -0.01, -0.01, -0.02,
  -0.02, -0.02, -0.02, -0.02, -0.02, -0.03, -0.03, -0.03, -0.03, -0.03, -0.03, -0.03,
  -0.04, -0.04, -0.04, -0.04, -0.04, -0.04, -0.04, -0.05, -0.05, -0.05, -0.05, -0.05,
  -0.05, -0.06, -0.06, -0.06, -0.06, -0.06, -0.06, -0.06, -0.07, -0.07, -0.07, -0.07,
  -0.07, -0.07, -0.07, -0.08, -0.08, -0.08, -0.08, -0.08, -0.08, -0.09, -0.09, -0.09,
  -0.09, -0.09, -0.10, -0.10, -0.11, -0.12, -0.13, -0.14, -0.16, -0.18, -0.20, -0.23,
  -0.26, -0.28, -0.31, -0.34, -0.37, -0.40, -0.42, -0.44, -0.46, -0.47, -0.49, -0.50,
  -0.51, -0.51, -0.52, -0.52, -0.52, -0.52, -0.52, -0.52, -0.52, -0.52, -0.51, -0.51,
  -0.50, -0.49, -0.49, -0.48, -0.47, -0.46, -0.45, -0.43, -0.42, -0.41, -0.39, -0.37,
  -0.34, -0.32, -0.29, -0.26, -0.23, -0.19, -0.16, -0.13, -0.10, -0.07, -0.05, -0.03,
  -0.01, 0.00, 0.01, 0.01, 0.02, 0.02, 0.02, 0.01, 0.00, -0.01, -0.03, -0.06,
  -0.08, -0.12, -0.16, -0.20, -0.25, -0.30, -0.35, -0.40, -0.45, -0.50, -0.55, -0.61,
  -0.67, -0.73, -0.80, -0.87, -0.96, -1.05, -1.14, -1.24, -1.34, -1.44, -1.55, -1.65,
  -1.76, -1.88, -1.99, -2.12, -2.26, -2.40, -2.56, -2.74, -2.92, -3.13, -3.34, -3.57,
  -3.81, -4.06, -4.31, -4.57, -4.83, -5.10, -5.37, -5.63, -5.90, -6.17, -6.44, -6.71,
  -6.98, -7.25, -7.52, -7.79, -8.06, -8.33, -8.60, -8.86, -9.12, -9.38, -9.63, -9.88,
  -10.13, -10.37, -10.60, -10.82, -11.03, -11.24, -11.44, -11.63, -11.82, -12.00, -12.18, -12.36,
  -12.53, -12.71, -12.88, -13.05, -13.22, -13.38, -13.54, -13.69, -13.84, -13.97, -14.09, -14.20,
  -14.30, -14.39, -14.46, -14.52, -14.57, -14.61, -14.64, -14.66, -14.68, -14.69, -14.70, -14.71,
  -14.71, -14.72, -14.72, -14.72, -14.72, -14.72, -14.71, -14.71, -14.70, -14.69, -14.68, -14.66,
  -14.63, -14.60, -14.56, -14.51, -14.46, -14.39, -14.31, -14.23, -14.13, -14.03, -13.92, -13.81,
  -13.68, -13.56, -13.42, -13.29, -13.15, -13.00, -12.86, -12.71, -12.55, -12.39, -12.23, -12.06,
  -11.88, -11.70, -11.51, -11.31, -11.11, -10.90, -10.69, -10.47, -10.25, -10.04, -9.82, -9.61,
  -9.39, -9.18, -8.98, -8.78, -8.59, -8.40, -8.22, -8.04, -7.88, -7.72, -7.57, -7.42,
  -7.28, -7.13, -6.99, -6.84, -6.69, -6.54, -6.37, -6.20, -6.02, -5.84, -5.64, -5.43,
  -5.21, -4.98, -4.75, -4.50, -4.26, -4.01, -3.76, -3.51, -3.26, -3.01, -2.78, -2.54,
  -2.31, -2.10, -1.89, -1.69, -1.51, -1.34, -1.18, -1.03, -0.89, -0.76, -0.64, -0.52,
  -0.39, -0.27, -0.15, -0.02, 0.11, 0.25, 0.39, 0.53, 0.67, 0.81, 0.96, 1.10,
  1.25, 1.39, 1.53, 1.67, 1.80, 1.92, 2.04, 2.14, 2.23, 2.31, 2.37, 2.42,
  2.46, 2.49, 2.51, 2.53, 2.53, 2.54, 2.53, 2.53, 2.51, 2.49, 2.47, 2.43,
  2.39, 2.34, 2.29, 2.22, 2.15, 2.07, 1.99, 1.90, 1.81, 1.72, 1.63, 1.54,
  1.44, 1.35, 1.26, 1.17, 1.07, 0.98, 0.88, 0.78, 0.69, 0.60, 0.51, 0.43,
  0.35, 0.27, 0.20, 0.13, 0.05, -0.03, -0.10, -0.19, -0.27, -0.35, -0.44, -0.51,
  -0.58, -0.65, -0.70, -0.75, -0.78, -0.81, -0.83, -0.84, -0.85, -0.85, -0.84, -0.83,
  -0.82, -0.80, -0.77, -0.74, -0.70, -0.65, -0.60, -0.54, -0.48, -0.42, -0.36, -0.29,
  -0.23, -0.17, -0.11, -0.05, 0.00, 0.06, 0.11, 0.16, 0.21, 0.27, 0.31, 0.36,
  0.40, 0.44, 0.47, 0.50, 0.53, 0.55, 0.56, 0.58, 0.59, 0.61, 0.62, 0.63,
  0.64, 0.66, 0.67, 0.68, 0.69, 0.71, 0.72, 0.74, 0.75, 0.77, 0.78, 0.80,
  0.81, 0.83, 0.85, 0.86, 0.88, 0.90, 0.91, 0.93, 0.94, 0.96, 0.97, 0.98,
  0.99, 1.00, 1.01, 1.02, 1.03, 1.04, 1.05, 1.06, 1.07, 1.09, 1.10, 1.12,
  1.14, 1.16, 1.18, 1.20, 1.22, 1.24, 1.26, 1.28, 1.29, 1.31, 1.32, 1.33,
  1.34, 1.35, 1.36, 1.37, 1.37, 1.38, 1.38, 1.39, 1.39, 1.39, 1.39, 1.40,
  1.40, 1.40, 1.40, 1.40, 1.40, 1.40, 1.39, 1.39, 1.38, 1.37, 1.35, 1.33,
  1.31, 1.28, 1.24, 1.21, 1.16, 1.12, 1.07, 1.03, 0.99, 0.94, 0.90, 0.87,
  0.83, 0.80, 0.77, 0.74, 0.71, 0.68, 0.65, 0.62, 0.59, 0.56, 0.54, 0.51,
  0.47, 0.44, 0.41, 0.37, 0.33, 0.29, 0.25, 0.21, 0.16, 0.12, 0.09, 0.05,
  0.01, -0.02, -0.05, -0.08, -0.11, -0.14, -0.17, -0.19, -0.22, -0.24, -0.27, -0.29,
  -0.31, -0.33, -0.35, -0.37, -0.39, -0.41, -0.43, -0.45, -0.47, -0.49, -0.52, -0.54,
  -0.57, -0.60, -0.63, -0.66, -0.68, -0.71, -0.74, -0.77, -0.79, -0.81, -0.83, -0.85,
  -0.87, -0.89, -0.90, -0.92, -0.93, -0.95, -0.97, -0.99, -1.01, -1.04, -1.07, -1.11,
  -1.15, -1.19, -1.24, -1.30, -1.36, -1.43, -1.50, -1.58, -1.66, -1.74, -1.82, -1.91,
  -1.99, -2.07, -2.15, -2.23, -2.30, -2.36, -2.42, -2.47, -2.51, -2.54, -2.57, -2.60,
  -2.61, -2.62, -2.63, -2.64, -2.64, -2.63, -2.62, -2.60, -2.58, -2.54, -2.50, -2.44,
  -2.36, -2.27, -2.16, -2.03, -1.88, -1.72, -1.54, -1.34, -1.14, -0.93, -0.71, -0.49,
  -0.26, -0.03, 0.20, 0.43, 0.67, 0.90, 1.14, 1.38, 1.61, 1.84, 2.06, 2.28,
  2.49, 2.68, 2.87, 3.04, 3.21, 3.37, 3.52, 3.66, 3.80, 3.93, 4.06, 4.19,
  4.32, 4.45, 4.59, 4.71, 4.84, 4.97, 5.09, 5.22, 5.33, 5.44, 5.55, 5.64,
  5.73, 5.81, 5.88, 5.94, 6.00, 6.04, 6.08, 6.11, 6.14, 6.16, 6.17, 6.18,
  6.19, 6.19, 6.19, 6.19, 6.18, 6.17, 6.16, 6.15, 6.13, 6.10, 6.08, 6.05,
  6.01, 5.98, 5.94, 5.89, 5.85, 5.80, 5.74, 5.69, 5.63, 5.56, 5.49, 5.42,
  5.34, 5.26, 5.18, 5.09, 4.99, 4.89, 4.79, 4.68, 4.57, 4.46, 4.35, 4.24,
  4.13, 4.02, 3.91, 3.80, 3.69, 3.57, 3.45, 3.31, 3.17, 3.02, 2.86, 2.70,
  2.53, 2.35, 2.18, 2.01, 1.85, 1.69, 1.54, 1.40, 1.26, 1.14, 1.01, 0.89,
  0.76, 0.64, 0.52, 0.39, 0.27, 0.14, 0.03, -0.09, -0.20, -0.30, -0.40, -0.50,
  -0.60, -0.71, -0.81, -0.92, -1.03, -1.15, -1.28, -1.40, -1.53, -1.66, -1.78, -1.91,
  -2.04, -2.17, -2.29, -2.42, -2.55, -2.67, -2.80, -2.93, -3.05, -3.17, -3.29, -3.41,
  -3.53, -3.65, -3.77, -3.88, -3.99, -4.10, -4.20, -4.30, -4.39, -4.47, -4.55, -4.61,
  -4.66, -4.71, -4.74, -4.77, -4.79, -4.80, -4.80, -4.80, -4.80, -4.79, -4.77, -4.75,
  -4.72, -4.68, -4.63, -4.58, -4.52, -4.44, -4.36, -4.28, -4.18, -4.08, -3.97, -3.86,
  -3.74, -3.62, -3.49, -3.37, -3.25, -3.12, -3.00, -2.88, -2.77, -2.66, -2.56, -2.46,
  -2.37, -2.28, -2.20, -2.13, -2.06, -2.00, -1.94, -1.88, -1.83, -1.78, -1.73, -1.69,
  -1.64, -1.61, -1.57, -1.54, -1.51, -1.49, -1.47, -1.45, -1.44, -1.43, -1.42, -1.41,
  -1.41, -1.41, -1.41, -1.40, -1.40, -1.40, -1.40, -1.40, -1.40, -1.40, -1.40, -1.39,
  -1.39, -1.39, -1.39, -1.39, -1.39, -1.38, -1.38, -1.37, -1.37, -1.36, -1.35, -1.34,
  -1.33, -1.31, -1.30, -1.28, -1.27, -1.25, -1.24, -1.22, -1.21, -1.19, -1.18, -1.17,
  -1.15, -1.14, -1.13, -1.11, -1.10, -1.09, -1.07, -1.06, -1.05, -1.03, -1.02, -1.01,
  -0.99, -0.98, -0.97, -0.95, -0.94, -0.93, -0.91, -0.90, -0.89, -0.87, -0.86, -0.85,
  -0.83, -0.82, -0.81, -0.79, -0.78, -0.77, -0.75, -0.74, -0.73, -0.71, -0.70, -0.69,
  -0.67, -0.66, -0.65, -0.63, -0.62, -0.61, -0.59, -0.58, -0.57, -0.55, -0.54, -0.53,
  -0.51, -0.50, -0.49, -0.47, -0.46, -0.45, -0.43, -0.42, -0.41, -0.39, -0.38, -0.37,
  -0.35, -0.34, -0.33, -0.31, -0.30, -0.29, -0.27, -0.26, -0.25, -0.23, -0.22, -0.21,
  -0.19, -0.18, -0.17, -0.15, -0.14, -0.13, -0.12, -0.10, -0.09, -0.08, -0.06, -0.05,
  -0.04, -0.02, -0.01, 0.00, 0.02, 0.03, 0.04, 0.06, 0.07, 0.08, 0.10, 0.11,
  0.12, 0.14, 0.15, 0.16, 0.18, 0.19, 0.20, 0.22, 0.23, 0.24, 0.26, 0.27,
  0.28, 0.30, 0.31, 0.32, 0.34, 0.35, 0.36, 0.37, 0.39, 0.40, 0.41, 0.42,
  0.42, 0.43, 0.44, 0.44, 0.45, 0.45, 0.45, 0.45, 0.45, 0.44, 0.44, 0.43,
  0.42, 0.40, 0.38, 0.36, 0.33, 0.31, 0.28, 0.25, 0.22, 0.20, 0.18, 0.16,
  0.14, 0.12, 0.11, 0.11, 0.10, 0.09, 0.09, 0.09, 0.08, 0.08, 0.08, 0.08,
  0.08, 0.08, 0.07, 0.07, 0.07, 0.07, 0.07, 0.07, 0.07, 0.06, 0.06, 0.06,
  0.06, 0.06, 0.06, 0.06, 0.05, 0.05, 0.05, 0.05, 0.05, 0.05, 0.04, 0.04,
  0.04, 0.04, 0.04, 0.04, 0.04, 0.03, 0.03, 0.03, 0.03, 0.03, 0.03, 0.03,
  0.02, 0.02, 0.02, 0.02, 0.02, 0.02, 0.01, 0.01, 0.01, 0.01, 0.01, 0.01,
  0.01, 0.00, 0.00, 0.00,
];
